import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { NavLink, useNavigate } from 'react-router-dom';
// import Localization from '../../../shared/localization/Localization.component';
import { useModal } from '@/hooks';
import { Avatar, Localization } from '@/components';

interface Props {
  isOpened: boolean;
  setIsOpened: (val: boolean) => void;
  userProfile?: any;
}

interface LinkProps {
  to: string;
  text: string;
  className?: string;
  setIsOpened: (val: boolean) => void;
}

function Link({ to, text, className, setIsOpened }: LinkProps) {
  return (
    <NavLink
      to={to}
      onClick={() => setIsOpened(false)}
      className={({ isActive }) =>
        classNames('font-medium px-6 py-5 text-center', isActive && 'text-blue-500', className)
      }
    >
      {text}
    </NavLink>
  );
}

export default function HamburgerMenu({ isOpened, setIsOpened, userProfile }: Props) {
  const { t } = useTranslation();
  const { showModal } = useModal();
  const navigate = useNavigate();

  return (
    <>
      {isOpened && (
        <div className='w-screen h-screen fixed left-0 top-0 z-50 bg-black/95 text-white lg:hidden'>
          <div className='h-16 px-4 w-full flex justify-between items-center'>
            {userProfile ? (
              <Link
                to='/logout'
                text={t('Log out')}
                setIsOpened={setIsOpened}
                className='icon-logout mr-1'
              />
            ) : (
              <button
                onClick={() => {
                  showModal('login');
                  setIsOpened(false);
                }}
              >
                <i className='icon-login mr-1' />
                {t('Login')}
              </button>
            )}
            <i className='icon-close text-2xl' onClick={() => setIsOpened(false)} />
          </div>

          {userProfile && (
            <div className='m-4 flex flex-col justify-center items-center space-y-1'>
              {/*<img*/}
              {/*  src={userProfile.media.path}*/}
              {/*  className='w-20 h-20 rounded-full border border-gray-100'*/}
              {/*/>*/}
              <div
                className='flex flex-col justify-center items-center space-y-1'
                onClick={() => {
                  navigate('/profile');
                  setIsOpened(false);
                }}
              >
                <Avatar
                  name={userProfile.user.username}
                  src={userProfile?.avatar?.src}
                  className='w-20 h-20'
                />
                <p className='font-semibold'>
                  {t('Hi')}, <NavLink to='/profile'>{userProfile.user.username}</NavLink>
                </p>
                <div className='flex text-xs font-normal space-x-2'>
                  <span>
                    {t('Points')}: <span className='font-bold'>{userProfile.currentXp}</span>
                  </span>
                  <span>
                    {t('Tickets')}: <span className='font-bold'>{userProfile.currentTicket}</span>
                  </span>
                </div>
              </div>
              <div className='flex text-sm space-x-2'>
                <NavLink to='/profile' className='p-2' onClick={() => setIsOpened(false)}>
                  <i className='icon-user' />
                  {t('My Progress')}
                </NavLink>
                <NavLink to='/settings' className='p-2' onClick={() => setIsOpened(false)}>
                  <i className='icon-gear' />
                  {t('Settings')}
                </NavLink>
              </div>
            </div>
          )}

          <div className='m-4 flex flex-col bg-black/20 rounded-3xl divide-y divide-gray-900'>
            {userProfile ? (
              <>
                <Link to='/tasks' text={t('Tasks')} setIsOpened={setIsOpened} />
                <Link to='/campaigns' text={t('Campaigns')} setIsOpened={setIsOpened} />
                <Link to='/projects' text={t('Brands')} setIsOpened={setIsOpened} />
                <Link to='/clans' text={t('Clans')} setIsOpened={setIsOpened} />
                <Link to='/leaderboards' text={t('Leaderboards')} setIsOpened={setIsOpened} />
                <Link to='/how-it-works' text={t('How It Works')} setIsOpened={setIsOpened} />
              </>
            ) : (
              <>
                <Link to='/login' text={t('Login')} setIsOpened={setIsOpened} />
                <Link to='/register' text={t('Register')} setIsOpened={setIsOpened} />
                <Link to='/tos' text={t('Terms & Conditions')} setIsOpened={setIsOpened} />
                <Link to='/privacy' text={t('Privacy Policy')} setIsOpened={setIsOpened} />
                <Link to='/cookies' text={t('Cookie Policy')} setIsOpened={setIsOpened} />
              </>
            )}
          </div>

          <div className='absolute left-4 bottom-4'>
            <Localization />
          </div>
        </div>
      )}
    </>
  );
}
